import React from 'react';
import { Button } from '@odin-labs/components';

export function SupportButton(): JSX.Element {
  return (
    <div className="odin-flex odin-justify-center">
      <Button
        as="a"
        href="https://help.useodin.com/"
        rel="noopener noreferrer"
        shape="round"
        target="_blank"
        text="Get help"
        theme="secondary"
      />
    </div>
  );
}
